import { render, staticRenderFns } from "./myPrescribe.vue?vue&type=template&id=6f064cc9&scoped=true&"
import script from "./myPrescribe.vue?vue&type=script&lang=js&"
export * from "./myPrescribe.vue?vue&type=script&lang=js&"
import style0 from "./myPrescribe.vue?vue&type=style&index=0&lang=css&"
import style1 from "./myPrescribe.vue?vue&type=style&index=1&id=6f064cc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f064cc9",
  null
  
)

export default component.exports